import './chunk-1fafdf15.js';
import './chunk-bd4264c6.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { F as Field } from './chunk-5d5e2574.js';
export { F as BField } from './chunk-5d5e2574.js';
var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Field);
  }
};
use(Plugin);
export default Plugin;